import axios from 'axios';
import { OLD_WN_API_URL } from '../globals';

export const oldWnAxiosClient = axios.create({
  baseURL: OLD_WN_API_URL,
  withCredentials: true,
});
